import React from 'react';
import './App.css';
import Navbar from './components/Navbar';
import AiMlPortfolio from './components/AiMlPortfolio';
import IndustriesPage from './components/IndustriesPage';
import AboutUsPage from './components/AboutUsPage';
import InsightsPage from './components/InsightsPage';
import ContactModal from './components/ContactModal';
import Footer from './components/Footer';
import SplashScreen from './components/SplashScreen';
import VoiceAiPage from './components/VoiceAiPage';
import AgenticAiPage from './components/AgenticAiPage';
import ChatbotPage from './components/ChatbotPage';
import NlpPage from './components/NlpPage';
import MsFabricPage from './components/MsFabricPage';
import RagPage from './components/RagPage';
import GenAiPage from './components/GenAiPage';
import DataAnalyticsPage from './components/DataAnalyticsPage';
import LlmPage from './components/LlmPage';
import BiPage from './components/BiPage';

function App() {
  const [currentPage, setCurrentPage] = React.useState('portfolio');
  const [showContactModal, setShowContactModal] = React.useState(false);
  const [showSplash, setShowSplash] = React.useState(true);

  const handleSplashComplete = () => {
    setShowSplash(false);
  };

  const navigateTo = (page) => {
    setCurrentPage(page);
    window.scrollTo(0, 0);
  };

  const handleContactClick = () => {
    setShowContactModal(true);
  };

  return (
    <>
      {showSplash && <SplashScreen onComplete={handleSplashComplete} />}
      
      {!showSplash && (
        <div className="App fade-in-app">
          <Navbar
        onNavigate={navigateTo}
        onContactClick={handleContactClick}
        activePage={currentPage}
      />

      {currentPage === 'portfolio' && <AiMlPortfolio onContactClick={handleContactClick} />}
      {currentPage === 'industries' && <IndustriesPage />}
      {currentPage === 'about' && <AboutUsPage />}
      {currentPage === 'insights' && <InsightsPage />}
      {currentPage === 'voice-ai' && <VoiceAiPage onContactClick={handleContactClick} />}
      {currentPage === 'agentic-ai' && <AgenticAiPage onContactClick={handleContactClick} />}
      {currentPage === 'chatbot' && <ChatbotPage onContactClick={handleContactClick} />}
      {currentPage === 'nlp' && <NlpPage onContactClick={handleContactClick} />}
      {currentPage === 'ms-fabric' && <MsFabricPage onContactClick={handleContactClick} />}
      {currentPage === 'rag' && <RagPage onContactClick={handleContactClick} />}
      {currentPage === 'gen-ai' && <GenAiPage onContactClick={handleContactClick} />}
      {currentPage === 'data-analytics' && <DataAnalyticsPage onContactClick={handleContactClick} />}
      {currentPage === 'llm' && <LlmPage onContactClick={handleContactClick} />}
      {currentPage === 'bi' && <BiPage onContactClick={handleContactClick} />}

      <Footer />

      <ContactModal
        isOpen={showContactModal}
        onClose={() => setShowContactModal(false)}
          />
        </div>
      )}
    </>
  );
}

export default App;
